import { Record } from '../transit'

const Driver = Record({
  _id: null,
  name: '',
  gender: '',
  firstName: '',
  lastName: '',
  birthdate: '',
  email: '',
  phoneNumber: '',
  company: null,
  companyName: '',
  companyActive: true,
  drivingLicenceExpireDate: '',
  medicalExaminationExpireDate: '',
  trainingExpireDate: '',
  adrExpirationDate: '',
  employmentFinished: false,

  attendanceLocation: '',
  attendanceCourseType: '',
  archived: false,
  state: '',
  timetable: null

}, 'Driver')

export default Driver



// WEBPACK FOOTER //
// ./src/common/drivers/Driver.js